const cancelappointments = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Cancel Appointments",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    info_box: {
                      type: "checkbox",
                      label: "",
                      hideLabel: false,
                      placeholder: "Info Box",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_title: {
                      type: "text",
                      label: "Info Title",
                      placeholder: "Enter Info Title",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_description: {
                      type: "ckeditor",
                      label: "Info Description",
                      placeholder: "Enter Description",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "editor-toolbar-bg-change",
                      size: "12",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    description: {
                      type: "ckeditor",
                      label: "Page Description",
                      placeholder: "Enter Description",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "editor-toolbar-bg-change",
                      size: "12",
                      style: "",
                    },
                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Options",
            service: "categoryTypes",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: true,
              deleteButton: false,
              addNewSuccessTitle: "Type Added!",
              addNewSuccessMessage: "Type Added Successfully!",
              addNewErrorTitle: "Type Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Type Deleted!",
              deleteSuccessMessage: "Type Deleted Successfully!",
              deleteErrorTitle: "Type Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Type Activated!",
              activeSuccessMessage: "Type Activated Successfully!",
              activeErrorTitle: "Type Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Type Updated!",
              updateSuccessMessage: "Type Updated Successfully!",
              updateErrorTitle: "Type Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Type",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Type",
                    placeholder: "Enter Type",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  active: true,
                  nhs_app: true,
                  patient_access: true,
                  systm_online: true,
                  contact_us: true,
                  description: "",
                },
              },
            },
            children: [
              {
                type: "optionsTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Types",
                  type: "typeList",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  rules: {
                    condition: {
                      key: "enable_webform",
                      value: false,
                    },
                    actions: [
                      {
                        actionType: "CHANGE_VALUE",
                        targetKey: "prescription_request_type",
                        newValue: false,
                      },
                      {
                        actionType: "CHANGE_VALUE",
                        targetKey: "collection_form",
                        newValue: false,
                      },
                    ],
                  },
                  form: {
                    layout_1: {
                      description: {
                        type: "ckeditor",
                        label: "Description",
                        placeholder: "Enter Description",
                        required: true,
                        info: false,
                        character_count: 2000,
                        disabled: false,
                        class: "editor-toolbar-bg-change",
                        size: "12",
                        style: "",
                      },
                      nhs_app: {
                        type: "toggle",
                        label: "NHS App",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "3",
                        style: "",
                      },
                      patient_access: {
                        type: "toggle",
                        label: "Patient Access",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "3",
                        style: "",
                      },
                      systm_online: {
                        type: "toggle",
                        label: "System Online",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "3",
                        style: "",
                      },
                    },
                    layout_2: {
                      description: {
                        type: "ckeditor",
                        label: "Description",
                        placeholder: "Enter Description",
                        required: true,
                        info: false,
                        character_count: 2000,
                        disabled: false,
                        class: "editor-toolbar-bg-change",
                        size: "12",
                        style: "",
                      },
                      hr0: {
                        type: "hr",
                        size: "12",
                      },
                      enable_webform: {
                        type: "toggle",
                        label: "Webform",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      template: {
                        type: "select",
                        label: "Template",
                        placeholder: "Select Template",
                        displayOn: "enable_webform",
                        displayOnValue: "true",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        options: ["Template A", "Template B"],
                      },
                      hr2: {
                        type: "hr",
                        size: "12",
                        displayOn: "enable_webform",
                        displayOnValue: "true",
                      },
                      "confirmation-message": {
                        type: "ckeditor",
                        label: "Confirmation Message",
                        placeholder: "Confirmation Message",
                        required: true,
                        info: false,
                        character_count: 2000,
                        disabled: false,
                        class: "editor-toolbar-bg-change",
                        size: "12",
                        style: "",
                        displayOn: "enable_webform",
                        displayOnValue: "true",
                      },
                    },
                    layout_3: {
                      prescription_slip: {
                        type: "toggle",
                        label: "Prescription Slip",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      hr1: {
                        type: "hr",
                        size: "12",
                      },
                      prescription_box: {
                        type: "toggle",
                        label: "Prescription Box",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      formSection: {
                        components: {
                          image_url: {
                            type: "imgSelect",
                            label: "",
                            placeholder: "Select Image",
                            load_url: "",
                            required: false,
                            info: false,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                          },
                          image_url2: {
                            type: "imgSelect",
                            label: " ",
                            placeholder: "Select Image",
                            load_url: "",
                            required: false,
                            info: false,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOn: "prescription_box",
                        displayOnValue: "true",
                      },
                    },
                    layout_4: {
                      description: {
                        type: "ckeditor",
                        label: "Description",
                        placeholder: "Enter Description",
                        required: true,
                        info: false,
                        character_count: 2000,
                        disabled: false,
                        class: "editor-toolbar-bg-change",
                        size: "12",
                        style: "",
                      },
                      call_the_practice: {
                        type: "toggle",
                        label: "Call the Practice",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      phone_number: {
                        type: "text",
                        label: "Phone Number",
                        placeholder: "Phone Number",
                        displayOn: "call_the_practice",
                        displayOnValue: "true",
                        required: false,
                        info: false,
                        character_count: 15,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                      },
                    },
                    layout_5: {
                      type: {
                        type: "select",
                        label: "Type",
                        placeholder: "Select type",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        options: [
                          "Accurx",
                          "Anima",
                          "EConsult",
                          "Klinik",
                          "Patchs",
                          "Rapid Health",
                          "System Connect",
                        ],
                      },
                      title: {
                        type: "text",
                        label: "Title",
                        placeholder: "Enter the title",
                        required: true,
                        info: true,
                        character_count: 250,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      description: {
                        type: "ckeditor",
                        label: "Description",
                        placeholder: "Enter Description",
                        required: true,
                        info: false,
                        character_count: 2000,
                        disabled: false,
                        class: "editor-toolbar-bg-change",
                        size: "12",
                        style: "",
                      },
                      hr1: {
                        type: "hr",
                        size: "12",
                      },
                      title_link: {
                        type: "text",
                        label: "Link",
                        placeholder: "Enter Link",
                        required: true,
                        info: true,
                        character_count: 1000,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                      },
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "FAQ",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New FAQ",
                type: "page",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  title: {
                    type: "text",
                    label: "Question",
                    placeholder: "Enter Question",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  answer: "",
                },
              },
            },
            children: [
              {
                type: "patientGroupTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Questions",
                  type: "list",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    title: {
                      type: "text",
                      label: "Question",
                      placeholder: "Enter Question",
                      required: true,
                      info: false,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    answer: {
                      type: "ckeditor",
                      label: "Answer",
                      placeholder: "Enter Answer",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { cancelappointments };
